import { ICorrectedParams, IParams } from '@src/interfaces';
import { useLocation, useParams as useRealParams } from 'react-router';
import qs from 'qs';

interface IQueryParams {
  search?: string,
  object_type?: string,
}

const useParams = (): ICorrectedParams => {

  const params = useRealParams<IParams>();
  const location = useLocation();
  const query: IQueryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  const to_string = (str: string | undefined): string | undefined => {
    return str == '.' ? undefined : str;
  }

  return {
    email: to_string(params.email),
    token: to_string(params.token),
    type: to_string(params.type ?? query.object_type),
    terms: to_string(params.terms ?? query.search),
    widget: to_string(params.widget),
  }
}

export default useParams;